<template>
  <nav v-if="breadcrumbs.length > 0" class="flex items-center gap-2">
    <RouterLink
      v-for="(crumb, index) in breadcrumbs"
      :key="crumb.path"
      :to="crumb.path"
      :class="[
        'text-sm transition-colors',
        index === breadcrumbs.length - 1
          ? 'text-gray-900 dark:text-white font-semibold'
          : 'text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400'
      ]"
    >
      {{ crumb.label }}
    </RouterLink>
  </nav>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const { t } = useI18n()
const route = useRoute()

const breadcrumbs = computed(() => {
  const paths = route.path.split('/').filter((p) => p)
  const breadcrumbs: Array<{ path: string; label: string }> = [{ path: '/dashboard', label: t('g.ana_sayfa') }]

  let currentPath = ''
  for (const path of paths) {
    currentPath += `/${path}`
    if (currentPath === '/dashboard') continue

    const labels: Record<string, string> = {
      employees: t('nav.employees'),
      projects: t('nav.projects'),
      companies: t('nav.projects'),
      requests: t('nav.requests'),
      payroll: t('nav.payroll'),
      documents: t('nav.documents'),
      reports: t('nav.reports'),
      settings: t('nav.settings'),
      'org-hierarchy': t('nav.organization'),
      logs: t('nav.logs'),
      'audit-logs': t('nav.logs'),
      add: t('breadcrumb.add'),
      edit: t('breadcrumb.edit'),
      view: t('breadcrumb.view')
    }

    const label = labels[path] || path

    if (!breadcrumbs.find((b) => b.path === currentPath)) {
      breadcrumbs.push({ path: currentPath, label })
    }
  }

  const metaKey = route.meta.titleKey as string | undefined
  if (metaKey && breadcrumbs.length) {
    breadcrumbs[breadcrumbs.length - 1].label = t(metaKey)
  }

  return breadcrumbs
})
</script>
